'use strict';

var _ = require('underscore');
var isSimpleObject = require('./isSimpleObject');

var cloneValue = function(target, value) {
	var result;
	if (isSimpleObject(value)) {
		result = deepExtend(
			isSimpleObject(target) ? target : {}, value
		);
	} else if (_(value).isArray()) {
		result = _(value).map(function(item) {
			return cloneValue(null, item);
		});
	} else {
		result = value;
	}

	return result;
};

var deepExtend = function() {
	var target = arguments[0] || {};
	var extensions = _(arguments).rest();

	_(extensions).each(function(object) {
		_(object).each(function(value, key) {
			target[key] = cloneValue(target[key], value);
		});
	});

	return target;
};

module.exports = deepExtend;
